import { render, staticRenderFns } from "./ElementDescriptionSection.vue?vue&type=template&id=aa9c1194&scoped=true"
import script from "./ElementDescriptionSection.vue?vue&type=script&lang=js"
export * from "./ElementDescriptionSection.vue?vue&type=script&lang=js"
import style0 from "./ElementDescriptionSection.vue?vue&type=style&index=0&id=aa9c1194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa9c1194",
  null
  
)

export default component.exports